export default "__VITE_ASSET__CVQ9sfrs__"